<template>
  <div class="info-area">
    <el-dropdown trigger="click" @command="dropdownComm" class="info-area__dropdown">
      <span class="el-dropdown-link">
        {{username}}<i class="el-icon-arrow-down el-icon--right"></i>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="profile">{{$t('sidebarDropDown.profile')}}</el-dropdown-item>
        <el-dropdown-item command="lock">{{$t('sidebarDropDown.lock')}}</el-dropdown-item>
        <el-dropdown-item command="logout">{{$t('sidebarDropDown.logout')}}</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <div @click="jumpToProfile" class="info-area__avatar">
      <img :src="avatarUrl" />
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import { setToken, removeToken } from '@/utils/auth'
import axios from 'axios'
import storage from '@/utils/storage'

export default {
  name: 'demo',
  data() {
    return {
      username: Cookies.get("srs_nickname"),
      avatarUrl: Cookies.get("srs_avatar")
    }
  },
  methods: {
    dropdownComm(command) {
      switch (command) {
        case 'logout':
          this.logouthandle()
          break
        case 'lock':
          this.lockhandle()
          break
        case 'profile':
          this.jumpToProfile()
          break
      }
    },
    async logouthandle() {
      var thiz = this;
      axios.post(this.$store.getters.getApiValue+'/logout.do').then(function (response) {
					var data = response.data;
					if(data.status == "200"){
						Cookies.remove('user')
						Cookies.remove('srs_nickname')
						Cookies.remove('srs_avatar')
						Cookies.remove('menus')
						storage.set('visitedViews', []);
          	removeToken()
					  window.location.reload()
					}else{
					  thiz.$message.error(data.message);
					}
				}).catch(function (error) {
					console.log(error);
					thiz.$message.error("系统异常,请与管理员联系!");
				});
    },
    lockhandle() {
      this.$store.dispatch('setLockState', 'lock')
      this.$router.push({
        path: '/lock'
      })
      this.$message.success(this.$t('lock.locked'))
    },
    jumpToProfile() {
      this.$router.push({
        path: '/profile/index'
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
.inline-block-box
  display inline-block
  vertical-align middle

.info-area
  &__dropdown
    @extend .inline-block-box
    cursor pointer
  &__avatar
    @extend .inline-block-box
    padding-left 10px
    width 40px
    height 40px
    overflow hidden
    cursor pointer
    img
      border-radius 50%
      width 100%
      height auto
</style>
